var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "RegistrationForm" } },
    [
      _c(
        "form",
        {
          staticClass: "w-100 d-flex flex-column align-items-baseline",
          attrs: { action: "/action_page.php", id: "registrationPublicForm" }
        },
        [
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.name,
                  expression: "inputs.name"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "name",
                placeholder: _vm.translations.company_name + "*",
                name: "name"
              },
              domProps: { value: _vm.inputs.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputs.country,
                    expression: "inputs.country"
                  }
                ],
                staticClass: "form-control country-select",
                attrs: { name: "country", id: "" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.inputs,
                      "country",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c(
                  "option",
                  {
                    attrs: { selected: "", disabled: "" },
                    domProps: { value: null }
                  },
                  [_vm._v(_vm._s(_vm.translations.country) + "*")]
                ),
                _vm._v(" "),
                _vm._l(_vm.countries, function(country) {
                  return _c("option", { domProps: { value: country } }, [
                    _vm._v(_vm._s(country))
                  ])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.city,
                  expression: "inputs.city"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "mesto",
                placeholder: _vm.translations.city + "*",
                name: "mesto"
              },
              domProps: { value: _vm.inputs.city },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "city", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.address,
                  expression: "inputs.address"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "adresa",
                placeholder: _vm.translations.address + "*",
                name: "adresa"
              },
              domProps: { value: _vm.inputs.address },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "address", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.zip,
                  expression: "inputs.zip"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "psc",
                placeholder: _vm.translations.zip + "*",
                name: "psc"
              },
              domProps: { value: _vm.inputs.zip },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "zip", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.phone,
                  expression: "inputs.phone"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "phone",
                placeholder: _vm.translations.phone + "*",
                name: "phone"
              },
              domProps: { value: _vm.inputs.phone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "phone", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.email,
                  expression: "inputs.email"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "email",
                id: "email",
                placeholder: _vm.translations.email_form + "*",
                name: "email"
              },
              domProps: { value: _vm.inputs.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "email", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.web,
                  expression: "inputs.web"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "web",
                placeholder:
                  _vm.translations.web +
                  " (format https://www.example.com) " +
                  "*",
                name: "web"
              },
              domProps: { value: _vm.inputs.web },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "web", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.gps_lat,
                  expression: "inputs.gps_lat"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "latitude",
                placeholder:
                  _vm.translations.gps_lat + " (format xx.xxxxxx) " + "*",
                name: "gps_lat"
              },
              domProps: { value: _vm.inputs.gps_lat },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "gps_lat", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-control-wrap my-1" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputs.gps_lon,
                  expression: "inputs.gps_lon"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "longitude",
                placeholder:
                  _vm.translations.gps_lon + " (format xx.xxxxxx) " + "*",
                name: "gps_lon"
              },
              domProps: { value: _vm.inputs.gps_lon },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "gps_lon", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mb-2 mt-1",
              staticStyle: { overflow: "hidden", "min-width": "600px" }
            },
            [
              _c("div", {
                staticStyle: {
                  "margin-right": "10px",
                  float: "left",
                  width: "22px",
                  height: "22px",
                  display: "inline-block",
                  background:
                    "transparent url('../images/checkbox.png') no-repeat bottom center"
                },
                style: [
                  _vm.inputs.gdpr
                    ? { "background-position": "top center" }
                    : { "background-position": "bottom center" }
                ],
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onCheck()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { float: "left", cursor: "default" } },
                [
                  _vm._v(_vm._s(_vm.translations.agree_with_gdpr_part1) + " "),
                  _c(
                    "a",
                    {
                      staticClass: "aura-link",
                      staticStyle: {
                        display: "inline",
                        "text-transform": "none",
                        color: "#0575E6"
                      },
                      attrs: { href: "/preview-file/gdpr.pdf" }
                    },
                    [_vm._v(_vm._s(_vm.translations.agree_with_gdpr_part2))]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.response.result && _vm.response.result !== null
        ? _c("div", { staticClass: "alert alert-success mt-3" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.response.message) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.response.result && _vm.response.result !== null
        ? _c("div", { staticClass: "alert alert-danger mt-3" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.response.message) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default mt-3 g-recaptcha",
          attrs: {
            id: "btn-confirm",
            "data-sitekey": "6LdqIWMcAAAAAJxHWZZK5VWWwhktAzusocLwsJcY",
            type: "submit"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.showConfirmationModal($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.translations.confirm))]
      ),
      _vm._v(" "),
      _c("registration-form-modal", {
        attrs: { inputs: _vm.inputs, translations: _vm.translations },
        on: { submitted: _vm.setResponse }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }